import { cn, PaletteUtils } from '@shared/utils';
import { AddressType, type ProfileResponse } from '@shared/api';
import { AddressItem } from './item';

interface AddressesProps {
  className?: string;
  user: ProfileResponse;
}

export const Addresses = (props: AddressesProps) => {
  return (
    <section
      className={cn(
        'grid grid-cols-2 gap-8 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <AddressItem type={AddressType.Primary} address={props.user.primaryAddress} />
      <AddressItem type={AddressType.Billing} address={props.user.billingAddress} />
    </section>
  );
};
